import React from 'react';
import styles from 'styles/modules/Post.module.scss';

const Post = ({ children }) => {
    return <article className={styles.post}>{children}</article>;
};

export default Post;
